module.exports = __webpack_public_path__ + "static/media/ktm-07.3cfc48c3.jpg";